import React from "react";
import { useSelector } from "react-redux";
import Default from "./default";

const RequireAuth = (props) => {
  const auth = useSelector(
    (state) => state.oidc.user !== null && !state.oidc.user.expired
  );
  if (auth) return <>{props.children}</>;
  return <Default />;
};

export default RequireAuth;
